<div class="geofence">
  @if (!isGeofenceSet()) {
    <div class="geofence__not-set">
      <div class="geofence__icons--warning">
        <span class="dv-icons">warning_filled</span>
      </div>
      <div class="geofence__text">
        {{ 'AssetLocationInfoTab.GeofenceNotSet' | translate }}
      </div>
    </div>
  }
  @if (isGeofenceSet()) {
    <div class="geofence__set">
      <div class="geofence__icons--success">
        <span class="dv-icons">check_circle</span>
      </div>
      <div class="geofence__text">
        {{ 'AssetLocationInfoTab.GeofenceSet' | translate }}
      </div>
    </div>
  }
</div>
